(function () {
	'use strict';

	/** Лимит API: не более 5 запросов в секунду с одного IP. */
	const MAX_PER_SECOND = 5;
	const MIN_INTERVAL_MS = Math.ceil(1000 / MAX_PER_SECOND);
	const SELECTOR = 'img[data-catalog-img="1"]:not([data-catalog-img-loaded="1"])';

	const queue = [];
	const queued = new WeakSet();
	let lastStartAt = 0;
	let timer = null;

	const settleImage = (img) => {
		img.dataset.catalogImgLoaded = '1';
		img.classList.remove('is-deferred');

		// Двойной rAF — чтобы transition сработал и для картинок из кэша.
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				img.classList.add('is-loaded');
			});
		});
	};

	const startNext = () => {
		timer = null;

		while (queue.length > 0) {
			const img = queue.shift();

			if (!img || !img.isConnected || img.dataset.catalogImgLoaded === '1') {
				continue;
			}

			const src = img.dataset.src || '';
			if (!src) {
				settleImage(img);
				continue;
			}

			const now = Date.now();
			const wait = Math.max(0, MIN_INTERVAL_MS - (now - lastStartAt));

			if (wait > 0) {
				queue.unshift(img);
				timer = setTimeout(startNext, wait);
				return;
			}

			lastStartAt = Date.now();

			let settled = false;
			const done = () => {
				if (settled) {
					return;
				}

				settled = true;
				settleImage(img);
			};

			img.addEventListener('load', done, { once: true });
			img.addEventListener('error', done, { once: true });

			// Только src — без srcset, чтобы один img = один запрос к API.
			img.removeAttribute('srcset');
			img.removeAttribute('sizes');
			img.src = src;

			if (img.complete) {
				done();
			}

			if (queue.length > 0) {
				timer = setTimeout(startNext, MIN_INTERVAL_MS);
			}

			return;
		}
	};

	const processQueue = () => {
		if (timer !== null) {
			return;
		}

		startNext();
	};

	const enqueue = (root) => {
		const scope = root && root.querySelectorAll ? root : document;

		scope.querySelectorAll(SELECTOR).forEach((img) => {
			if (queued.has(img)) {
				return;
			}

			queued.add(img);
			queue.push(img);
		});

		processQueue();
	};

	window.CarrotsBoxCatalogImages = {
		enqueue,
		MAX_PER_SECOND,
		MIN_INTERVAL_MS,
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => enqueue(document));
	} else {
		enqueue(document);
	}
})();
